import type { BookingResponse } from '@/shared/api';
import { classifyChannel } from '../../calendar/calendarHelpers';
import { agendaDate } from '../agenda/agendaCardModel';

export function calcNights(checkInIso: string, checkOutIso: string): number {
  const a = new Date(checkInIso);
  const b = new Date(checkOutIso);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return 0;
  return Math.max(0, Math.round((b.getTime() - a.getTime()) / 86_400_000));
}

export function isOta(booking: Pick<BookingResponse, 'source'>): boolean {
  return booking.source === 'Ota';
}

/** Kanalname für Sätze: „Booking.com“ statt `BookingCom`; einen unbekannten Kanal wie geliefert. */
export function channelName(channel: string | null | undefined): string {
  // Ohne Kanalnamen wäre classifyChannel „Manuell“ – bei einer Kanalbuchung falsch.
  if (!channel) return 'Buchungsportal';
  const meta = classifyChannel(channel);
  return meta.slug === 'otherOta' ? (channel ?? 'den Kanal') : meta.label;
}

// Parst eine Channex-Mirror-JSON-Spalte (ServicesJson / TaxesJson / …) in ein Array.
// Liefert [] bei null/leer/kaputt — die Spalten sind nicht garantiert wohlgeformt.
export function parseJsonArray<T>(raw: string | null | undefined): T[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as T[]) : [];
  } catch {
    return [];
  }
}

/**
 * Ein Maß für „Onboarding abgeschlossen“ – vorher galten vier verschiedene: abgegeben
 * (`onboardingCompletedAt`) oder endgültig (`status === 'Final'`) zählt beides als erledigt.
 */
export function onboardingDone(
  guest: { status: string; onboardingCompletedAt: string | null } | null | undefined,
): boolean {
  return !!guest && (guest.status === 'Final' || !!guest.onboardingCompletedAt);
}

/**
 * „Mo 19.10.“ – mit Jahr, wenn es nicht das des Objekt-Heute ist. Vergangene und künftige
 * Buchungen bleiben so eindeutig, ohne dass jede Zeile das Jahr trägt.
 */
export function stayDate(iso: string, objectToday: string | null | undefined): string {
  const year = iso.slice(0, 4);
  const current = (objectToday ?? new Date().toISOString()).slice(0, 4);
  return year === current ? agendaDate(iso) : `${agendaDate(iso)}${year}`;
}
